import leads from './leads';
import setup from './setup';
export default {  
	leads : leads,
	setup : setup,
} 
